import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnter } from 'src/utils/changeEnter';

const RatingAnswerSurvey_0301: FC = () => {
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  return (
    <>
      <div className="root_view root_view_0301">
        <div className="template">
          <div className="center_horizon close">
            <button />
          </div>
          <div className="center_wrapper">
            <div className="logo">
              <button />
            </div>
            <div className="title">
              <div className="title_inner">
                {changeEnter(text?.title_0301?.[currentIndex])}
              </div>
            </div>
            <div className="sub_title">
              <div className="sub_title_inner">
                {changeEnter(text?.sub_title_0301?.[currentIndex])}
              </div>
            </div>
            <div className="star_wrapper">
              <div className="star_inner action">
                <button />
              </div>
              {[...Array(4)].map(() => (
                <div className="star_inner">
                  <button />
                </div>
              ))}
            </div>
            <textarea
              className="textarea"
              placeholder={btnText?.text_area_0301?.[currentIndex]}
            />
          </div>
          <div className="center_horizon bottom">
            <button className="button action">
              {btnText?.button_0301?.[currentIndex]}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default RatingAnswerSurvey_0301;
